var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIconV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.64578 9.22073L9.10615 2.92651C9.93734 2.1167 11.2855 2.1167 12.1167 2.92651L12.9796 3.76722C13.8108 4.57703 13.8108 5.89052 12.9796 6.70033L6.49374 13.0194C6.12287 13.3807 5.62005 13.5835 5.09521 13.5835H2.43903C2.19228 13.5835 1.99399 13.3854 2.00014 13.1451L2.06695 10.5338C2.08024 10.0403 2.28751 9.56978 2.64578 9.22073ZM12.3587 4.37212L11.4958 3.53142C11.0075 3.05568 10.2153 3.05568 9.72702 3.53142L9.22549 4.02006L11.8575 6.58379L12.3587 6.09543C12.847 5.61969 12.847 4.84786 12.3587 4.37212ZM3.26665 9.82563L8.60461 4.62496L11.2366 7.1887L5.87286 12.4145L5.80152 12.4781C5.60447 12.639 5.35481 12.728 5.09521 12.728L2.88897 12.7277L2.94472 10.5557C2.95209 10.2816 3.06751 10.0197 3.26665 9.82563ZM14 13.1558C14 12.9196 13.8034 12.7281 13.561 12.7281H8.98066L8.92109 12.732C8.7068 12.7603 8.54164 12.9392 8.54164 13.1558C8.54164 13.392 8.73819 13.5835 8.98066 13.5835H13.561L13.6205 13.5796C13.8348 13.5513 14 13.3723 14 13.1558Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIconV2);
export default __webpack_public_path__ + "static/media/pencil_Icon_v2.8df4c00542b32714f2f79a3a12ff2018.svg";
export { ForwardRef as ReactComponent };